<template>
  <v-dialog
    persistent
    max-width="500"
    v-model="dialog"
    @keydown.esc="closeModal(true)"
  >
    <v-card>
      <v-card-title>
        <slot name="title"></slot>
      </v-card-title>
      <v-card-text>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeModal(true)">Non</v-btn>
        <v-btn @click="sendConfirmEvent" color="primary" :loading="loading">
          Oui
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
  name: "ConfirmDialog",
  props: {
    open: Boolean,
    loading: Boolean,
  },
  setup(props, { emit }) {
    /* Computed */
    const dialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Méthodes */
    const closeModal = function (isCancel) {
      dialog.value = false;
      if (isCancel) {
        emit("cancel");
      }
    };
    const sendConfirmEvent = function () {
      emit("confirm");
      closeModal(false);
    };

    return {
      dialog,
      closeModal,
      sendConfirmEvent,
    };
  },
});
</script>
